module.exports = __webpack_public_path__ + "img/v4_underlyingPriceManageList_h.5ee838df.png";